export default "__VITE_ASSET__oA161500__"